// extracted by mini-css-extract-plugin
export default {"avatar":"AvatarUpload_avatar__LBefN","uploadButton":"AvatarUpload_uploadButton__fTpVT","removePhotoButton":"AvatarUpload_removePhotoButton__RFRR3"};